import { render } from "./CustomerContactsList.vue?vue&type=template&id=e12e74e0&scoped=true&ts=true&lang=pug"
import script from "./CustomerContactsList.vue?vue&type=script&lang=ts"
export * from "./CustomerContactsList.vue?vue&type=script&lang=ts"

import "./CustomerContactsList.vue?vue&type=style&index=0&id=e12e74e0&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e12e74e0"]])

export default __exports__